define('home/templates/activityCardReply',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"card-reason\">\n"
    + ((stack1 = container.invokePartial(partials.userGroup,depth0,{"name":"userGroup","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<span class=\"icon-forward\"></span>"
    + ((stack1 = container.invokePartial(partials.userPreview,((stack1 = (depth0 != null ? depth0.target : depth0)) != null ? stack1.author : stack1),{"name":"userPreview","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " <span class=\"time\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.relativeTime : depth0), depth0))
    + "</span>\n</div>\n"
    + ((stack1 = container.invokePartial(partials.cardTitle,depth0,{"name":"cardTitle","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<div class=\"card-reply\" data-role=\"posts\"></div>\n<footer class=\"card-footer\" data-role=\"footer\"></div>\n";
},"usePartial":true,"useData":true})

});
